import { jsx as a, jsxs as $ } from "react/jsx-runtime";
import { QUERIES as d } from "@fcamna/shared-component-foundations";
import { fordProIcons as y } from "@fcamna/shared-icons";
import T, { useState as u, useEffect as w, useMemo as A } from "react";
import i from "styled-components";
import { u as v } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as E } from "./useWindowSize-88e90e04.mjs";
const { Checkmark: L, CancelClose: U, Edit: M } = y, D = i.div`
  display: ${(e) => e.theme.components.progressTrackerVertical.ProgressWrapper.display};
  flex-direction: ${(e) => e.theme.components.progressTrackerVertical.ProgressWrapper.flexDirection};
  flex-grow: ${({ $isVisible: e, ...r }) => e ? r.theme.components.progressTrackerVertical.ProgressWrapper.flexGrow.visible : r.theme.components.progressTrackerVertical.ProgressWrapper.flexGrow.default};
  height: ${({ $isLastStep: e, $isVisible: r, ...t }) => r || e ? t.theme.components.progressTrackerVertical.ProgressWrapper.height.visibleOrLastStep : t.theme.components.progressTrackerVertical.ProgressWrapper.height.default};
`, G = i.div`
  display: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepWrapper.display};
  gap: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepWrapper.gap};
  align-items: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepWrapper.alignItems};
  width: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepWrapper.width};
  @media ${d.tabletAndUp} {
    gap: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepWrapper.tabletAndUp.gap};
  }
`, j = i.div`
  width: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepIndicator.width};
  height: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepIndicator.height};
  border-radius: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepIndicator.borderRadius};
  box-sizing: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepIndicator.boxSizing};
  border: ${(e) => e.$error && e.$isActive ? e.theme.components.progressTrackerVertical.ProgressStepIndicator.border.errorActive : e.$editable ? e.theme.components.progressTrackerVertical.ProgressStepIndicator.border.editable : e.$error ? e.theme.components.progressTrackerVertical.ProgressStepIndicator.border.error : e.$isActive || e.$isCompleted ? e.theme.components.progressTrackerVertical.ProgressStepIndicator.border.activeCompleted : e.theme.components.progressTrackerVertical.ProgressStepIndicator.border.default};
  background-color: ${(e) => e.$error && e.$isActive ? e.theme.components.progressTrackerVertical.ProgressStepIndicator.backgroundColor.errorActive : e.$isActive || e.$editable ? e.theme.components.progressTrackerVertical.ProgressStepIndicator.backgroundColor.activeOrEditable : e.theme.components.progressTrackerVertical.ProgressStepIndicator.backgroundColor.default};
  color: ${({ $isActive: e, $editable: r, $isCompleted: t, $error: o, ...s }) => r ? s.theme.components.progressTrackerVertical.ProgressStepIndicator.color.editable : o && !e ? s.theme.components.progressTrackerVertical.ProgressStepIndicator.color.errorNotActive : e ? s.theme.components.progressTrackerVertical.ProgressStepIndicator.color.active : t ? s.theme.components.progressTrackerVertical.ProgressStepIndicator.color.completed : s.theme.components.progressTrackerVertical.ProgressStepIndicator.color.default};
  display: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepIndicator.display};
  justify-content: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepIndicator.justifyContent};
  align-items: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepIndicator.alignItems};
  transition: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepIndicator.transition};
  transition-duration: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepIndicator.transitionDuration};
  cursor: ${({ $editable: e, ...r }) => e ? r.theme.components.progressTrackerVertical.ProgressStepIndicator.cursor.editable : r.theme.components.progressTrackerVertical.ProgressStepIndicator.cursor.default};
  ${(e) => e.theme.components.progressTrackerVertical.mobileTypoGraphy};
  @media ${d.tabletAndUp} {
    height: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepIndicator.tabletAndUp.height};
    width: ${(e) => e.theme.components.progressTrackerVertical.ProgressStepIndicator.tabletAndUp.width};
    ${(e) => e.theme.components.progressTrackerVertical.commonTypoGraphy};
  }
`, O = i.div`
  position: ${(e) => e.theme.components.progressTrackerVertical.Connector.position};
  left: ${(e) => e.theme.components.progressTrackerVertical.Connector.left};
  width: ${(e) => e.theme.components.progressTrackerVertical.Connector.width};
  border-radius: ${(e) => e.theme.components.progressTrackerVertical.Connector.borderRadius};
  background-color: ${({ $isActive: e, ...r }) => e ? r.theme.components.progressTrackerVertical.Connector.backgroundColor.active : r.theme.components.progressTrackerVertical.Connector.backgroundColor.default};
  margin: ${(e) => e.theme.components.progressTrackerVertical.Connector.margin};
  transition: ${(e) => e.theme.components.progressTrackerVertical.Connector.transition};
  transition-duration: ${(e) => e.theme.components.progressTrackerVertical.Connector.transitionDuration};
  @media ${d.tabletAndUp} {
    left: ${(e) => e.theme.components.progressTrackerVertical.Connector.tabletAndUp.left};
  }
`, R = i.div`
  display: ${(e) => e.theme.components.progressTrackerVertical.ContentWrapper.display};
  height: ${(e) => e.theme.components.progressTrackerVertical.ContentWrapper.height};
`, x = i.div`
  height: ${(e) => e.theme.components.progressTrackerVertical.Wrapper.height};
  display: ${(e) => e.theme.components.progressTrackerVertical.Wrapper.display};
  flex-direction: ${(e) => e.theme.components.progressTrackerVertical.Wrapper.flexDirection};
`, z = i.label`
  color: ${({ $isCompleted: e, $editable: r, ...t }) => r ? t.theme.components.progressTrackerVertical.LabelWrapper.color.editable : e ? t.theme.components.progressTrackerVertical.LabelWrapper.color.completed : t.theme.components.progressTrackerVertical.LabelWrapper.color.default};
  cursor: ${(e) => e.$editable ? e.theme.components.progressTrackerVertical.LabelWrapper.cursor.editable : e.theme.components.progressTrackerVertical.LabelWrapper.cursor.default};
  ${(e) => e.theme.components.progressTrackerVertical.commonTypoGraphy};
`, H = i.div`
  display: ${({ $isVisible: e, ...r }) => e ? r.theme.components.progressTrackerVertical.ChildrenWrapper.display.visible : r.theme.components.progressTrackerVertical.ChildrenWrapper.display.default};
  margin: ${(e) => e.theme.components.progressTrackerVertical.ChildrenWrapper.margin};
  width: ${(e) => e.theme.components.progressTrackerVertical.ChildrenWrapper.width};
  @media ${d.tabletAndUp} {
    margin-left: ${(e) => e.theme.components.progressTrackerVertical.ChildrenWrapper.tabletAndUp.marginLeft};
  }
`, Q = i.div`
  ${(e) => `
    display: ${e.theme.components.progressTrackerVertical.ChildrenContainer.display};
    height: ${e.theme.components.progressTrackerVertical.ChildrenContainer.height};
    width: ${e.theme.components.progressTrackerVertical.ChildrenContainer.width};
    min-height: ${e.$isVisible ? e.theme.components.progressTrackerVertical.ChildrenContainer.minHeight.visible : e.theme.components.progressTrackerVertical.ChildrenContainer.minHeight.default};
    `}
`, q = ({
  children: e,
  activeStep: r = 1,
  onEdit: t,
  type: o = "progress",
  className: s
}) => {
  const l = v({ label: "Progress Tracker Vertical" }), p = T.Children.map(e, (n, g) => {
    var c;
    if (T.isValidElement(n) && n.type === b) {
      const m = n.props;
      return T.cloneElement(n, {
        _stepIndex: g + 1,
        activeStep: r,
        onClick: t,
        markerText: o === "progress" ? `${g + 1}` : (c = m == null ? void 0 : m.markerText) == null ? void 0 : c.substring(0, 2)
      });
    }
    return null;
  });
  return /* @__PURE__ */ a(
    x,
    {
      className: s,
      ...l,
      children: p
    }
  );
}, b = ({
  children: e,
  label: r = "Label",
  _stepIndex: t = 1,
  activeStep: o = 1,
  onClick: s,
  markerText: l = "",
  error: p = !1
}) => {
  const [n, g] = u(t <= o), [c, m] = u(!1), { width: h } = E(), k = h < 600, V = {
    height: k ? 16 : 20,
    width: k ? 16 : 20
  };
  w(() => {
    t <= o && g(!0);
  }, [o]);
  const C = () => {
    !k && t < o && m(!0);
  }, f = () => {
    t <= o && m(!1);
  }, P = (W, I) => {
    t < o && s && s(W, I);
  }, S = A(() => c && t < o ? /* @__PURE__ */ a(M, { ...V }) : p ? /* @__PURE__ */ a(U, { ...V }) : t < o ? /* @__PURE__ */ a(L, { ...V }) : l, [c, t, o, p, l]);
  return /* @__PURE__ */ $(
    D,
    {
      $isVisible: n,
      $isLastStep: !e,
      children: [
        /* @__PURE__ */ a(
          B,
          {
            markerContent: S,
            error: p,
            editable: c,
            index: t,
            activeStep: o,
            label: r,
            onMouseEnter: C,
            onMouseLeave: f,
            onClick: P
          }
        ),
        /* @__PURE__ */ $(R, { children: [
          e && /* @__PURE__ */ a(O, { $isActive: o > t }),
          /* @__PURE__ */ a(Q, { $isVisible: n, children: /* @__PURE__ */ a(H, { $isVisible: n, children: e }) })
        ] })
      ]
    }
  );
}, B = ({
  markerContent: e,
  label: r,
  onMouseEnter: t,
  onMouseLeave: o,
  onClick: s,
  index: l,
  activeStep: p,
  editable: n = !1,
  error: g = !1
}) => {
  const c = p >= l;
  return /* @__PURE__ */ $(
    G,
    {
      onMouseEnter: t,
      onMouseLeave: o,
      onClick: (h) => s(h, l),
      children: [
        /* @__PURE__ */ a(
          j,
          {
            $isActive: p === l,
            $isCompleted: c,
            $editable: n,
            $error: g,
            children: e
          }
        ),
        /* @__PURE__ */ a(
          z,
          {
            $isCompleted: c,
            $editable: n,
            children: r
          }
        )
      ]
    }
  );
};
q.Step = b;
export {
  q as ProgressTrackerVertical
};
